export enum AmountType {
  ToPay = 'TO_PAY',
  Total = 'TOTAL',
  Goodsvalue = 'GOODSVALUE',
  ProvidedServices = 'PROVIDED_SERVICES',
  DeliveryServices = 'DELIVERY_SERVICES',
  AlreadyPaid = 'ALREADY_PAID',
  Discount = 'DISCOUNT',
}
